import { useTRPC } from "../trpc/client";
import { useQuery } from "@tanstack/react-query";

/**
 * The comercios this user can reach. Read straight off the query cache — which
 * `AccessGate` has already filled before any dashboard component mounts — so
 * callers never see an empty list on their first render. Mirroring it into
 * component state instead would leave every consumer with its own copy that is
 * empty until an effect runs, which silently makes anything gated on the list
 * inert for a tick.
 */
export function useAvailableMerchants() {
  const trpc = useTRPC();
  const { data } = useQuery({
    ...trpc.merchants.list.queryOptions(undefined),
    staleTime: 60_000,
  });

  return { availableMerchants: data ?? [] };
}
